var path = '/templates/projects.campaigns/views/directives/campaign_creatives.html';
var html = "<table class=table><thead><tr><th class=campaign-detail-table-title></th><th>{{ 'projectsCampaignsViews.directives.campaignCreatives.kuupon_no_settei' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in template\"><th>{{v.label}}</th><td ng-bind-html=\"campaign.element.message | showElement : v\" class=campaign-setting-detail></td></tr><tr><th>{{ 'projectsCampaignsViews.directives.campaignCreatives.tsuika_css' | translate }}</th><td><code>\n          {{campaign.custom_css}}\n        </code></td></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_creatives.html
// module id = 1362
// module chunks = 0